import { Select, Text } from '../widget';
import { MultipleSelect } from '@/components/DynamicForm/widget';

export const getSystemFieldWidget = (fieldType) =>
  ({
    real_name: Text,
  }[fieldType]);

export const getCustomFieldWidget = (widgetType) =>
  ({
    TEXT: Text,
    SELECT: Select,
    MULTIPLE_SELECT: MultipleSelect,
  }[widgetType]);
